import {
  IWebsiteBuilderMarquee,
  IWebsiteBuilderMarqueeIconItem,
  IWebsiteBuilderMarqueeLinkItem,
  IWebsiteBuilderMarqueeParagraphItem,
  websiteBuilderGenerateMarqueeDesignStyles,
  websiteBuilderGenerateMarqueeIconItemDesignStyles,
  websiteBuilderGenerateMarqueeLinkItemDesignStyles,
  websiteBuilderGenerateMarqueeParagraphItemDesignStyles,
} from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderMarquee";
import { useAppSelector } from "hooks/redux";
import { websiteBuilderFindIconAsset, WEBSITE_BUILDER_MISSING_ICON_ASSET_SVG } from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderIcon";
import React, { Fragment } from "react";

interface IWebsiteBuilderMarqueeViewProps {
  node: IWebsiteBuilderMarquee;
}

export function WebsiteBuilderMarqueeView(props: IWebsiteBuilderMarqueeViewProps) {
  const { node } = props;

  const iconAssets = useAppSelector(store => store.websiteBuilderStore.editor.iconAssets);

  const settings = node.container.settings;
  const designStyles = websiteBuilderGenerateMarqueeDesignStyles(settings);

  function renderIconItem(item: IWebsiteBuilderMarqueeIconItem) {
    const itemDesignStyles = websiteBuilderGenerateMarqueeIconItemDesignStyles(item.settings);

    return (
      <div
        className={itemDesignStyles.className}
        style={itemDesignStyles.styleProperties}
        dangerouslySetInnerHTML={{ __html: websiteBuilderFindIconAsset(iconAssets, item.settings.assetIdentity)?.svg ?? WEBSITE_BUILDER_MISSING_ICON_ASSET_SVG }}
      />
    );
  }

  function renderLinkItem(item: IWebsiteBuilderMarqueeLinkItem) {
    const itemDesignStyles = websiteBuilderGenerateMarqueeLinkItemDesignStyles(item.settings);

    return (
      <a className={itemDesignStyles.className} style={itemDesignStyles.styleProperties}>{item.settings.label}</a>
    );
  }

  function renderParagraphItem(item: IWebsiteBuilderMarqueeParagraphItem) {
    const itemDesignStyles = websiteBuilderGenerateMarqueeParagraphItemDesignStyles(item.settings);

    return (
      <p className={itemDesignStyles.className} style={itemDesignStyles.styleProperties}>{item.settings.text}</p>
    );
  }

  function renderSeparator() {
    return (
      <div className={designStyles.separatorClassName} style={designStyles.separatorStyleProperties} aria-hidden="true" />
    );
  }

  return (
    <div className={designStyles.className} style={designStyles.styleProperties}>
      <div className={designStyles.trackClassName}>
        {settings.items.map((item, index) => (
          <Fragment key={item.id}>
            {item.type === "icon" ? (
              renderIconItem(item)
            ) : item.type === "link" ? (
              renderLinkItem(item)
            ) : (
              renderParagraphItem(item)
            )}
            {index < settings.items.length - 1 ? renderSeparator() : null}
          </Fragment>
        ))}
      </div>
    </div>
  );
}
